import { Component, Vue, Prop, Inject, Watch } from 'vue-property-decorator';
import { ProductType } from '@/common/types/ecommerce/ProductType';
import CustomFieldEditor from '../../components/custom-field/CustomFieldEditor.vue';
import DonationInput from '../../components/inputs/donation/DonationInput.vue';
import regexPattern from '@/components/directives/regexPattern-directive';
import { Addon } from '@/common/types/event/DtoAddon';
import { DtoCurrentUser } from '@/common/types/user/DtoCurrentUser';
import QuantityInput from '@/components/inputs/quantity/QuantityInput.vue';
import triggerPopover from '../directives/triggerPopover-directive';

@Component({
    name: 'Addon',
    components: {
        CustomFieldEditor,
        DonationInput,
        QuantityInput
    },
    directives: {
        regexPattern,
        triggerPopover
    }
})

export default class AddonItem extends Vue {

    @Prop({ required: true })
    addon!: Addon;

    @Prop({ required: false, default: false })
    showCustomFields!: boolean;

    @Prop({ required: true, default: true })
    showProductPrice!: boolean;

    @Inject('user')
    currentUser!: DtoCurrentUser;

    ProductType: any = ProductType; // Allows reference to this enum in template

    @Watch("addon.productPrice", { immediate: true })
    updatePricePaid() {
        if (this.addon.product.productType != ProductType.Donation) {
            this.addon.quantity.price = this.addon.productPrice; // Stores the actual price paid by the user
        }
    }

    get showAddOnItem() {
        var product = this.addon.product;
        if (product.hasPurchaseWindow && product.isOnlyVisibleInPurchaseWindow && !product.isWithinPurchaseWindow) {
            return false;
        }
        return true;
    }

    mounted() {
        if (this.addon.product.productType == ProductType.Donation) {
            this.addon.quantity.quantity = 1;
        }
    }
}